import { render, staticRenderFns } from "./FoodcourtCargo.vue?vue&type=template&id=23637c56"
import script from "./FoodcourtCargo.vue?vue&type=script&lang=js"
export * from "./FoodcourtCargo.vue?vue&type=script&lang=js"
import style0 from "./FoodcourtCargo.vue?vue&type=style&index=0&id=23637c56&prod&lang=scss"
import style1 from "./FoodcourtCargo.vue?vue&type=style&index=1&id=23637c56&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports